import { DEFAULT_EXAM_CATEGORIES } from "./defaults"
import { DIMENSION_EXAM_CATEGORIES } from "./dimensions"
import type { ExamCategoryStore } from "./types"

export const EXAM_CATEGORIES_STORE_KEY = "shell:exam-content-categories:v5"

export function applyCanonicalDomainNames(categories: ExamCategoryStore): ExamCategoryStore {
  const canonicalById = new Map(
    DEFAULT_EXAM_CATEGORIES
      .filter((category) => category.parentId === null)
      .map((category) => [category.id, category.name]),
  )
  return categories.map((category) => {
    const canonical = canonicalById.get(category.id)
    if (!canonical || category.parentId !== null) return category
    const wordCount = category.name.trim().split(/\s+/).filter(Boolean).length
    if (wordCount <= 1 && canonical !== category.name) {
      return { ...category, name: canonical }
    }
    return category
  })
}

/** Adds catalog nodes the saved list does not have yet. Custom nodes stay. */
export function mergeMissingDefaultCategories(categories: ExamCategoryStore): ExamCategoryStore {
  const ids = new Set(categories.map((category) => category.id))
  const missing = [...DEFAULT_EXAM_CATEGORIES, ...DIMENSION_EXAM_CATEGORIES].filter(
    (category) => !ids.has(category.id),
  )
  if (missing.length === 0) return categories
  return [...categories, ...missing.map((category) => ({ ...category }))]
}

export function readExamCategoryStore(raw: string | null): ExamCategoryStore {
  if (!raw) return mergeMissingDefaultCategories(DEFAULT_EXAM_CATEGORIES.map((category) => ({ ...category })))
  try {
    const parsed = JSON.parse(raw) as ExamCategoryStore
    if (!Array.isArray(parsed) || parsed.length === 0) {
      return mergeMissingDefaultCategories(DEFAULT_EXAM_CATEGORIES.map((category) => ({ ...category })))
    }
    return mergeMissingDefaultCategories(applyCanonicalDomainNames(parsed))
  } catch {
    return mergeMissingDefaultCategories(DEFAULT_EXAM_CATEGORIES.map((category) => ({ ...category })))
  }
}
